import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import qs from 'qs';
import { fetchJSON } from '../../../shared/helpers/apiCalls';
import { CREATE_USER, REQUEST_TOKEN } from './actionType';
import { authProcess } from './action';
import { accessTokenUrl, createDevUserUrl, getActiveMode } from '../../../shared/helpers/endPoints';
import { setAuthError, setAuthSuccess } from '../login/action';
import { getCountry } from '../../utils/action';
import { authService, userService } from '../../../modules/users/services/dependency.injection';

function* callCreateUser({ payload: { history, values } }) {
    const token = userService.authService.getToken('client-token');
    const modeType = getActiveMode();
    try {
        const devOptions = {
            method: 'POST',
            url: createDevUserUrl(modeType),
            data: JSON.stringify({
                businessName: values.businessName,
                countryId: values.country,
                email: values.email,
                password: values.password
            }),
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                'X-AUTH-PASSWORD': 'password'
            }
        };

        yield call(fetchJSON, devOptions);
        if (values && values.email) {
            try {
                localStorage.setItem('registered_email', values.email);
            } catch (e) {}
        }
        // stop loading
        yield put(authProcess(false));
        // history.push('/login');
        yield put(
            setAuthSuccess('Your Request has been successfully sent, please check your mail for further process')
        );
    } catch (error) {
        let message =
            error === undefined
                ? 'Something went wrong, Kindly check your network and try again later'
                : error?.data?.error?.message || error?.data?.message || 'Something went wrong, Kindly check your network and try again later';
        // stop loading
        yield put(authProcess(false));
        yield put(setAuthError(message));
    }
}

export function* callRequestToken() {
    const modeType = getActiveMode();

    try {
        const options = {
            method: 'POST',
            data: qs.stringify({ grant_type: 'client_credentials' }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            auth: userService.authService.basicToken(),
            url: accessTokenUrl(modeType)
        };
        const response = yield call(fetchJSON, options);
        // localStorage.setItem('seeking', response.data.access_token);
        authService.setToken('client-token', response.data.access_token);

        yield put(getCountry());
    } catch (error) {}
}

export function* watchCallCreateUser() {
    yield takeEvery(CREATE_USER, callCreateUser);
}

export function* watchRequestToken() {
    yield takeEvery(REQUEST_TOKEN, callRequestToken);
}

function* RegisterSaga() {
    yield all([fork(watchRequestToken), fork(watchCallCreateUser)]);
}

export default RegisterSaga;
